import { AxiosResponse } from 'axios';
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "academic-year";

export interface getAcademicYearListType extends pagination_list {
  search?: string;
}

export class AcademicYearApi extends BaseAPI {
  static createAcademicYear(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getAcademicYearById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updateAcademicYear(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteAcademicYear(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static updateAcademicYearStatus(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/status`, body);
  }

  static getAcademicYearList(query?: any): Promise<AxiosResponse> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
  static getAcademicYearListActive(query?: any): Promise<any> {
    return this.api.get(`${path}/list/only-active`, {
      params: { ...query },
    });
  }

  static getOnlyActiveAcademicYear(query?: any): Promise<AxiosResponse> {
    return this.api.get(`${path}/list/only-active`, {
      params: { ...query },
    });
  }
}